module.exports = __webpack_public_path__ + "img/game_0.29413b13.png";